/* Bioniks — Hızlı Görünüm modalı (/products/{handle}.js) */
(function () {
  function ensureModal() {
    if (document.getElementById('bioniksQuickView')) return;
    var wrap = document.createElement('div');
    wrap.innerHTML = '<div id="bioniksQuickView" class="bioniks-qv" aria-hidden="true" role="dialog" aria-modal="true" aria-labelledby="bioniksQvTitle">' +
      '<div class="bioniks-qv__overlay" data-qv-close></div>' +
      '<div class="bioniks-qv__dialog"><div class="bioniks-qv__panel">' +
      '<button type="button" class="bioniks-qv__close" data-qv-close aria-label="Kapat"><i class="icon feather icon-x" aria-hidden="true"></i></button>' +
      '<div id="bioniksQvLoading" class="bioniks-qv__loading" hidden><span class="bioniks-qv__spinner"></span><span>Ürün yükleniyor...</span></div>' +
      '<div id="bioniksQvError" class="bioniks-qv__error" hidden></div>' +
      '<div id="bioniksQvBody" class="bioniks-qv__body" hidden>' +
      '<div class="row g-xl-4 g-3"><div class="md:w-1/2 w-full"><div class="bioniks-qv__gallery">' +
      '<div class="bioniks-qv__main-wrap"><img id="bioniksQvMainImg" src="" alt="" class="bioniks-qv__main-img" width="500" height="500"></div>' +
      '<div id="bioniksQvThumbs" class="bioniks-qv__thumbs"></div></div></div>' +
      '<div class="md:w-1/2 w-full"><div class="bioniks-qv__content">' +
      '<span id="bioniksQvBadge" class="bioniks-qv__badge" hidden></span>' +
      '<p id="bioniksQvVendor" class="bioniks-qv__vendor"></p>' +
      '<h4 id="bioniksQvTitle" class="bioniks-qv__title"></h4>' +
      '<p id="bioniksQvDesc" class="bioniks-qv__desc"></p>' +
      '<div class="bioniks-qv__price-row"><div><label class="bioniks-qv__label">Fiyat</label><p id="bioniksQvPrice" class="bioniks-qv__price"></p></div>' +
      '<div id="bioniksQvQtyWrap"><label class="bioniks-qv__label" for="bioniksQvQty">Adet</label>' +
      '<div class="bioniks-qv__qty"><button type="button" class="bioniks-qv__qty-btn" data-qv-qty="-1" aria-label="Azalt">−</button>' +
      '<input type="number" id="bioniksQvQty" value="1" min="1" class="bioniks-qv__qty-input" readonly>' +
      '<button type="button" class="bioniks-qv__qty-btn" data-qv-qty="1" aria-label="Artır">+</button></div></div></div>' +
      '<div id="bioniksQvVariantWrap" class="bioniks-qv__variant-wrap" hidden><label class="bioniks-qv__label" for="bioniksQvVariant">Seçenek</label>' +
      '<select id="bioniksQvVariant" class="bioniks-qv__variant-select"></select></div>' +
      '<div class="bioniks-qv__actions">' +
      '<form id="bioniksQvForm" class="js-product-form" action="/cart/add" method="post">' +
      '<input type="hidden" name="id" id="bioniksQvVariantId" value=""><input type="hidden" name="quantity" id="bioniksQvQtyHidden" value="1">' +
      '<button type="submit" class="btn py-3 px-5 text-base font-Lufga inline-block font-medium leading-[1.2] border border-secondary bg-secondary text-white rounded-xl duration-700 uppercase">Sepete Ekle</button></form>' +
      '<button type="button" id="bioniksQvWishlist" class="btn py-3 px-5 text-base inline-flex gap-2.5 items-center justify-center font-medium font-Lufga leading-[1.2] border border-secondary rounded-xl duration-700 hover:bg-secondary hover:text-white js-wishlist-add">' +
      '<i class="icon feather icon-heart" aria-hidden="true"></i> Favorilere Ekle</button>' +
      '<a id="bioniksQvDetailLink" href="#" class="bioniks-qv__detail-link">Detaylı incele →</a></div>' +
      '<ul id="bioniksQvMeta" class="bioniks-qv__meta"></ul></div></div></div></div></div></div></div>';
    document.body.appendChild(wrap.firstChild);
  }

  ensureModal();
  var modal = document.getElementById('bioniksQuickView');
  if (!modal) return;

  var els = {
    loading: document.getElementById('bioniksQvLoading'),
    error: document.getElementById('bioniksQvError'),
    body: document.getElementById('bioniksQvBody'),
    mainImg: document.getElementById('bioniksQvMainImg'),
    thumbs: document.getElementById('bioniksQvThumbs'),
    badge: document.getElementById('bioniksQvBadge'),
    vendor: document.getElementById('bioniksQvVendor'),
    title: document.getElementById('bioniksQvTitle'),
    desc: document.getElementById('bioniksQvDesc'),
    price: document.getElementById('bioniksQvPrice'),
    qty: document.getElementById('bioniksQvQty'),
    qtyHidden: document.getElementById('bioniksQvQtyHidden'),
    variantWrap: document.getElementById('bioniksQvVariantWrap'),
    variantSelect: document.getElementById('bioniksQvVariant'),
    variantId: document.getElementById('bioniksQvVariantId'),
    wishlist: document.getElementById('bioniksQvWishlist'),
    detailLink: document.getElementById('bioniksQvDetailLink'),
    meta: document.getElementById('bioniksQvMeta')
  };

  var state = { product: null, variant: null };

  function fmtTRY(cents) {
    var v = (Number(cents) / 100).toFixed(2).split('.');
    return '\u20BA' + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1];
  }

  function esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }

  function stripHtml(html) {
    var d = document.createElement('div');
    d.innerHTML = html || '';
    var t = (d.textContent || d.innerText || '').replace(/\s+/g, ' ').trim();
    return t.length > 220 ? t.slice(0, 217) + '...' : t;
  }

  function showPanel(which) {
    els.loading.hidden = which !== 'loading';
    els.error.hidden = which !== 'error';
    els.body.hidden = which !== 'body';
  }

  function lockScroll(on) {
    document.documentElement.classList.toggle('bioniks-qv-open', on);
  }

  function close() {
    modal.classList.remove('bioniks-qv--open');
    modal.setAttribute('aria-hidden', 'true');
    lockScroll(false);
    state.product = null;
    state.variant = null;
  }

  function open() {
    modal.classList.add('bioniks-qv--open');
    modal.setAttribute('aria-hidden', 'false');
    lockScroll(true);
  }

  function renderPrice(variant) {
    var html = '<span class="bioniks-qv__price-current">' + fmtTRY(variant.price) + '</span>';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      html += ' <del class="bioniks-qv__price-old">' + fmtTRY(variant.compare_at_price) + '</del>';
      var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
      els.badge.textContent = '%' + pct + ' İndirim';
      els.badge.hidden = false;
    } else {
      els.badge.hidden = true;
    }
    els.price.innerHTML = html;
  }

  function pickVariant(product, variantId) {
    var v = product.variants.find(function (x) { return x.id === variantId; });
    if (!v) v = product.variants.find(function (x) { return x.available; }) || product.variants[0];
    state.variant = v;
    els.variantId.value = v.id;
    renderPrice(v);
    var formBtn = els.body.querySelector('#bioniksQvForm [type="submit"]');
    if (formBtn) {
      formBtn.disabled = !v.available;
      formBtn.textContent = v.available ? 'Sepete Ekle' : 'Çok Yakında';
    }
  }

  function brandLabel(product) {
    var v = (product && product.vendor) ? String(product.vendor) : '';
    if (/misimou/i.test(v)) return 'Dr. Misimou';
    if (/bioniks/i.test(v)) return 'Bioniks';
    if (/\(HY/i.test(v)) return v.split(' (')[0].trim();
    return v;
  }

  function renderGallery(product) {
    var images = product.images && product.images.length ? product.images : [];
    if (!images.length && product.featured_image) images = [product.featured_image];
    if (!images.length) {
      els.mainImg.src = '';
      els.mainImg.alt = product.title;
      els.thumbs.innerHTML = '';
      return;
    }
    els.mainImg.src = images[0];
    els.mainImg.alt = product.title;
    if (images.length < 2) {
      els.thumbs.innerHTML = '';
      els.thumbs.hidden = true;
      return;
    }
    els.thumbs.hidden = false;
    els.thumbs.innerHTML = images.map(function (src, i) {
      return '<button type="button" class="bioniks-qv__thumb' + (i === 0 ? ' is-active' : '') + '" data-qv-img="' + esc(src) + '">' +
        '<img src="' + esc(src.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1$2')) + '" alt="" width="56" height="56" loading="lazy">' +
        '</button>';
    }).join('');
  }

  function renderMeta(product, variant) {
    var rows = [];
    if (variant.sku) rows.push('<li><strong>Stok Kodu:</strong> ' + esc(variant.sku) + '</li>');
    if (product.type) rows.push('<li><strong>Kategori:</strong> ' + esc(product.type) + '</li>');
    if (product.tags && product.tags.length) {
      rows.push('<li><strong>Etiketler:</strong> ' + esc(product.tags.join(', ')) + '</li>');
    }
    els.meta.innerHTML = rows.join('');
  }

  function renderProduct(product) {
    state.product = product;
    var brand = brandLabel(product);
    els.vendor.textContent = brand;
    els.vendor.hidden = !brand;
    els.title.textContent = product.title;
    els.desc.textContent = stripHtml(product.description);
    els.detailLink.href = product.url;

    els.wishlist.setAttribute('data-product-id', product.id);
    els.wishlist.setAttribute('data-product-handle', product.handle);
    els.wishlist.setAttribute('data-product-title', product.title);
    els.wishlist.setAttribute('data-product-url', product.url);
    els.wishlist.setAttribute('data-product-image', product.featured_image || (product.images && product.images[0]) || '');
    els.wishlist.setAttribute('data-product-price', product.price);

    renderGallery(product);

    var variants = product.variants || [];
    if (variants.length > 1) {
      els.variantWrap.hidden = false;
      els.variantSelect.innerHTML = variants.map(function (v) {
        var label = v.title === 'Default Title' ? product.title : v.title;
        if (!v.available) label += ' (Çok yakında)';
        return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(label) + '</option>';
      }).join('');
      var first = variants.find(function (v) { return v.available; }) || variants[0];
      els.variantSelect.value = first.id;
      pickVariant(product, first.id);
    } else {
      els.variantWrap.hidden = true;
      pickVariant(product, variants[0] ? variants[0].id : null);
    }

    renderMeta(product, state.variant);
    els.qty.value = 1;
    els.qtyHidden.value = 1;
    showPanel('body');
  }

  function loadProduct(handle) {
    if (!handle) return;
    open();
    showPanel('loading');
    els.error.textContent = '';

    fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('notfound');
        return r.json();
      })
      .then(function (product) {
        renderProduct(product);
      })
      .catch(function () {
        els.error.textContent = 'Ürün yüklenemedi. Lütfen tekrar deneyin.';
        showPanel('error');
      });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('.js-quick-view');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      loadProduct(trigger.getAttribute('data-product-handle'));
      return;
    }
    if (e.target.closest && e.target.closest('[data-qv-close]')) {
      e.preventDefault();
      close();
      return;
    }
    var thumb = e.target.closest && e.target.closest('[data-qv-img]');
    if (thumb && modal.classList.contains('bioniks-qv--open')) {
      e.preventDefault();
      var src = thumb.getAttribute('data-qv-img');
      els.mainImg.src = src;
      els.thumbs.querySelectorAll('.bioniks-qv__thumb').forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
      return;
    }
    var qtyBtn = e.target.closest && e.target.closest('[data-qv-qty]');
    if (qtyBtn && modal.classList.contains('bioniks-qv--open')) {
      e.preventDefault();
      var delta = parseInt(qtyBtn.getAttribute('data-qv-qty'), 10) || 0;
      var n = Math.max(1, (parseInt(els.qty.value, 10) || 1) + delta);
      els.qty.value = n;
      els.qtyHidden.value = n;
    }
  });

  if (els.variantSelect) {
    els.variantSelect.addEventListener('change', function () {
      if (!state.product) return;
      pickVariant(state.product, parseInt(els.variantSelect.value, 10));
      renderMeta(state.product, state.variant);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('bioniks-qv--open')) close();
  });

  window.BioniksQuickView = { open: loadProduct, close: close };
})();
